module.exports = __webpack_public_path__ + "3127889e4df3d25420ffb3495d30260d.pdf";